import React from 'react';

import { CircularProgress } from '@mui/material';

import * as S from './styles';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';
import { COLORS } from 'styles/colors';

export interface SpinProps {
  spinning?: boolean;
  size?: 'small' | 'default' | 'large';
  tip?: string;
  delay?: number;
  fullscreen?: boolean;
  indicator?: React.ReactNode;
  centerHorizontally?: boolean;
  centerVertically?: boolean;
}

const Spin = ({
  spinning = true,
  size = 'default',
  tip,
  delay,
  fullscreen,
  indicator,
  centerHorizontally = false,
  centerVertically = false,
}: SpinProps) => {
  const theme = useThemeContext();

  const getMuiSize = () => {
    switch (size) {
      case 'small':
        return 20;
      case 'large':
        return 40;
      default:
        return 32;
    }
  };

  return (
    <S.SpinWrapper
      spinning={spinning}
      size={size}
      tip={tip}
      delay={delay}
      fullscreen={fullscreen}
      hasIcon={!!indicator}
      centerHorizontally={centerHorizontally}
      centerVertically={centerVertically}
    >
      {spinning &&
        (indicator || (
          <CircularProgress
            size={getMuiSize()}
            sx={{
              color: theme?.primary || COLORS.PRIMARY,
            }}
          />
        ))}
    </S.SpinWrapper>
  );
};

export default Spin;
